import withURLSearchParamsHandler from "../../../../../../components/hoc/withURLSearchParamsHandler";
import AgentHistory from "./AgentHistory";

const AgentHistoryWithURLSearchParamsHandler = withURLSearchParamsHandler(AgentHistory);
export default AgentHistoryWithURLSearchParamsHandler;